import { ISelectOption, selectOption } from '@/platform/controls/ISelectOption';
import { BodyType } from '@/services/BodyType';

export class BodyRelatedData {
	public readonly type: readonly ISelectOption<BodyType>[];

	public constructor() {
		this.type = [
			selectOption(BodyType.ACCREDITATION_INSTITUTE, 'Accreditation institute'),
			selectOption(BodyType.MEMBER, 'Member'),
			selectOption(BodyType.PARTNER, 'Partner'),
			selectOption(BodyType.QUALITY_LABEL, 'Quality label'),
			selectOption(BodyType.RANKING_INSTITUTE, 'Ranking institute'),
			selectOption(BodyType.SCHOLARSHIP_PROVIDER, 'Scholarship provider'),
			selectOption(BodyType.STUDENT_ASSOCIATION, 'Student association'),
		];
	}
}
